













































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    splitStringByCharacter,
    getIndexFromList,
    placeHolderArrayFields
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { MsgBox, Combobox, Breadcrums, CloseConfirmationModal } from '../../core/components';
import DynamicFields from './DynamicFields.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import { objectEach, time } from 'highcharts';
import Input from '../../core/components/Input.vue'
import Checkbox from '../../core/components/Checkbox.vue'

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        DynamicFields,
        Breadcrums,
        CloseConfirmationModal,
        Input,
        Checkbox
    }
})
export default class CreateSessionFrame extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() action: string;
    @Prop() visible: boolean;
    @Prop() editing: boolean;
    @Prop() editingEcu: boolean;
    @Prop() outsideProtocol: boolean;
    @Prop() editingProtocol: boolean;
    @Prop() actionEcuDialog: string;
    @Prop() fieldToPatch: object;
    @Prop() protocolSelected: any;
    dynamicFields: any = [];
    visibleCloseConfirmationModal: boolean = false;
    visibleModalCreateSessionFrame: boolean = false;
    modalTitle: string = '';
    submitButtonText: string = '';
    msgLoadingDialog: string = '';
    successPost: boolean | null = null;
    pendingRequest: boolean = false;
    pendingProtocolInitializations: boolean = false;
    pendingProtocolFinalizations: boolean = false;
    idScannerProtocol: number = 255;
    existsEmptyFields: number = 0;
    //base data
    sessionFrameDescription: string = '';
    sessionType: any | null = null;
    typesOptions: any = [];
    optionsTypes: any = [
        {
            id: 3,
            value: 'Frame Initialization',
            protocol_id: [0, 1, 2, 4, 5, 6],
            key: 'frame'
        },
        {
            id: 2,
            value: 'Fast Initialization',
            protocol_id: [0, 1],
            key: 'fast'
        },
        {
            id: 1,
            value: 'Baud Initialization',
            protocol_id: [0, 1],
            key: 'baud'
        }
    ];
    dynamicFormFields: any = [];
    errorResponse: any = {};
    //vmodels

    booleanOptions: any = [
        {
            value: true,
            description: 'true'
        },
        {
            value: false,
            description: 'false'
        }
    ];

    //protocols ids
    //ISO14230 > 0
    //ISO15765 > 1
    //J1939 > 2
    //J1587 > 4
    //SERIAL > 5
    //CAN > 6
    //Scanner > 255
    // fields:any = [];
    //v-models
    //BaudInitialization
    initAddr: number = 0;
    baudrate: number = 0;
    w1max: number = 0;
    w2max: number = 0;
    w3min: number = 0;
    w3max: number = 0;
    w4min: number = 0;
    w4max: number = 0;
    w5min: number = 0;
    //Fast Initialization
    wakeuppatternidletime: number = 0;
    wakeuppatternhightime: number = 0;
    wakeuppatternlowtime: number = 0;
    framelength: number = 0;
    multiframesnposition: number = 0;
    multiframeinitdataposition: number = 0;
    filterlength: number = 0;
    filterposition: number = 0;
    pgnnumber: number = 0;
    priority: number = 0;
    ecunumberposition: number = 0;
    header: number = 0;
    headerfilter: number = 0;
    frameArray: string = '';
    priorityString: string = '';
    filterpositionString: string = '';
    datafilter: string = '';
    datamask: string = '';
    headermask: string = '';
    filterdataarray: string = '';
    filtermaskarray: string = '';
    multiframeresponse: boolean | null = null;
    standardrequest: boolean | null = null;
    frameArrayIsValid: boolean = true;
    placeholderArrayFields: string = placeHolderArrayFields;

    fields: any = [
        {
            label: 'StandardRequest',
            key: 'standardrequest',
            type: 'select',
            options: this.booleanOptions,
            trackBy: 'value',
            value: 'description',
            noOptionsText: '',
            protocol_id: [2],
            required: true,
            model: this.standardrequest,
            finalization_id: [2],
            s_types: [3]
        },
        {
            label: 'PGN',
            key: 'pgnnumber',
            type: 'number',
            protocol_id: [2],
            finalization_id: [2],
            s_types: [3],
            required: true,
            model: this.pgnnumber
        },
        {
            label: 'TxPriority',
            key: 'priority',
            type: 'number',
            protocol_id: [2],
            finalization_id: [2],
            s_types: [3],
            required: true,
            model: this.priorityString
        },
        {
            label: 'TxPriority',
            key: 'priority',
            type: 'number',
            protocol_id: [4],
            finalization_id: [4],
            s_types: [3],
            required: true,
            model: this.priority
        },
        {
            label: 'MF.Response',
            key: 'multiframeresponse',
            type: 'select',
            options: this.booleanOptions,
            trackBy: 'value',
            value: 'description',
            noOptionsText: '',
            protocol_id: [0],
            finalization_id: [0],
            s_types: [2, 3],
            required: true,
            model: this.multiframeresponse
        },
        {
            label: 'MF.SN.Position',
            key: 'multiframesnposition',
            type: 'number',
            protocol_id: [0],
            finalization_id: [0],
            s_types: [2, 3],
            required: true,
            model: this.multiframesnposition
        },
        {
            label: 'MF.InitDataPosition',
            key: 'multiframeinitdataposition',
            type: 'number',
            protocol_id: [0],
            finalization_id: [0],
            s_types: [2, 3],
            required: true,
            model: this.multiframeinitdataposition
        },
        {
            label: 'RxFilterData',
            key: 'filterdataarray',
            type: 'text',
            placeholder: this.placeholderArrayFields,
            maxLength: 50,
            protocol_id: [0, 1, 2, 4, 5, 6],
            finalization_id: [0, 1, 4, 5, 6],
            s_types: [2, 3],
            required: true,
            model: this.filterdataarray,
            compare: 'filtermaskarray'
        },
        {
            label: 'RxFilterMask',
            key: 'filtermaskarray',
            placeholder: this.placeholderArrayFields,
            type: 'text',
            maxLength: 50,
            protocol_id: [0, 1, 2, 4, 5, 6],
            finalization_id: [0, 1, 4, 5, 6],
            s_types: [2, 3],
            required: true,
            model: this.filtermaskarray,
            compare: 'filterdataarray'
        },
        {
            label: 'RxFilterPosition',
            key: 'filterposition',
            type: 'number',
            protocol_id: [2],
            finalization_id: [0, 1, 4, 5, 6],
            s_types: [2, 3],
            required: true,
            model: this.filterpositionString
        },
        {
            label: 'RxFilterPosition',
            key: 'filterposition',
            type: 'number',
            protocol_id: [0, 1, 4, 5, 6],
            finalization_id: [0, 1, 4, 5, 6],
            s_types: [2, 3],
            required: true,
            model: this.filterposition
        },
        // {
        //     label: '',
        //     key: 'framedataarray',
        //     type: 'text',
        //     placeholder: 'Descripción',
        //     maxLength: 50,
        //     protocol_id: [2],
        //     required: true,
        //     model: this.framedataarray
        // },
        {
            label: 'TxHeader',
            key: 'header',
            type: 'number',
            protocol_id: [6],
            required: true,
            model: this.header,
            finalization_id: [6],
            s_types: [3]
        },
        {
            label: 'RxHeaderFilter',
            key: 'headerfilter',
            type: 'text',
            protocol_id: [6],
            finalization_id: [6],
            s_types: [3],
            required: true,
            model: this.headerfilter
        },
        {
            label: 'RxHeaderMask',
            key: 'headermask',
            type: 'text',
            placeholder: 'Descripción',
            maxLength: 50,
            protocol_id: [6],
            finalization_id: [6],
            s_types: [3],
            required: true,
            model: this.headermask
        },
        {
            label: 'EcuNumberPosition',
            key: 'ecunumberposition',
            type: 'number',
            protocol_id: [4],
            finalization_id: [4],
            s_types: [3],
            required: true,
            model: this.ecunumberposition
        },
        //BaudInitialization
        {
            label: 'InitAddr',
            key: 'initaddress',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1, 2],
            required: true,
            model: this.initAddr
        },
        {
            label: 'Baudrate',
            key: 'baudrate',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1],
            required: true,
            model: this.baudrate
        },
        {
            label: 'W1max',
            key: 'w1max',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1],
            required: true,
            model: this.w1max
        },
        {
            label: 'W2max',
            key: 'w2max',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1],
            required: true,
            model: this.w2max
        },
        {
            label: 'W3min',
            key: 'w3min',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1],
            required: true,
            model: this.w3min
        },
        {
            label: 'W3max',
            key: 'w3max',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1],
            required: true,
            model: this.w3max
        },
        {
            label: 'W4min',
            key: 'w4min',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1],
            required: true,
            model: this.w4min
        },
        {
            label: 'W4max',
            key: 'w4max',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1],
            required: true,
            model: this.w4max
        },
        {
            label: 'W5min',
            key: 'w5min',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [1],
            required: true,
            model: this.w5min
        },
        //Fast Initialization
        {
            label: 'WUPIdleTime',
            key: 'wakeuppatternidletime',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [2],
            required: true,
            model: this.wakeuppatternidletime
        },
        {
            label: 'WUPHighTime',
            key: 'wakeuppatternhightime',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [2],
            required: true,
            model: this.wakeuppatternhightime
        },
        {
            label: 'WUPLowTime',
            key: 'wakeuppatternlowtime',
            type: 'number',
            protocol_id: [0, 1],
            s_types: [2],
            required: true,
            model: this.wakeuppatternlowtime
        }
    ];

    actionModal: string = '';
    breadcrumsItems: any = [];
    seeMoreFields: boolean = false;
    dynamicFieldsAreValid: boolean = true;

    updateSeeMoreFields(value){
        this.checkBoxChangeByUser(value);
        this.seeMoreFields = value;
    }

    get showSomeFields(){
        return this.seeMoreFields
    }

    //methods
    mounted() {
        this.setBreadcrums();
        this.actionModal = this.action;
        this.seeMoreFields = true;
        if (this.editing) {
            let fieldDescription;
            if (this.action === 'Inicialización') {
                fieldDescription = this.fieldToPatch['description'];
                let fieldType = this.fieldToPatch['type'].toLowerCase();
                let indexOfType = getIndexFromList(this.optionsTypes, 'key', fieldType);
                this.updateSessionType(this.optionsTypes[indexOfType]);
            } else {
                fieldDescription = this.fieldToPatch['description'];
            }
            this.frameArray = this.fieldToPatch['framearray'];

            this.modalTitle = 'Modificar ' + this.action + ' <b> - ' + fieldDescription + '</b>';

            this.sessionFrameDescription = fieldDescription;
            this.submitButtonText = 'Modificar ' + this.action;
        } else {
            this.modalTitle = 'Crear ' + this.action + ' <b> - ' + this.protocolSelected['value'] + '</b>';
            this.submitButtonText = 'Crear ' + this.action;
        }

        this.visibleModalCreateSessionFrame = this.visible;

        if (this.action === 'Finalización' || this.action === 'Session Frame') {
            //set finalization fields
            this.updateFieldsFinalization(Number(this.protocolSelected['id']));
        } else {
            this.filterTypesOptions();
        }

        if (this.editing) {
            setTimeout(() => {
                this.loadPatchDataToDynamicFields();
            }, 200);
        } else {
            if (this.protocolSelected && this.protocolSelected['id'] == 2 && this.action !== 'Inicialización') {
                this.updateFormFields();
            }
        }

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_CLOSE_CHILDREN_COMPONENTS, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_VISIBLE, () => {
            this.closeModal();
        });
    }


    updateSessionFrameDescription(value){
        this.sessionFrameDescription = value;
    }
    updateFrameArray(value){
        this.frameArray = value;
    }


    dynamicFieldsValidation(value) {
        this.dynamicFieldsAreValid = value;
    }

    updateFormFields() {
        if (this.protocolSelected !== null) {
            if (this.protocolSelected['id'] == 2) {
                this.moreFieldsAction(true);
            }
            this.dynamicFields = this.getFieldsByProtocolId(this.fields, Number(this.protocolSelected['id']));
        } else {
            this.moreFieldsAction(false);
            this.dynamicFields = this.fields;
        }
    }

    loadPatchDataToDynamicFields() {
        //enable or disable checkbox j1939
        if (this.protocolSelected['id'] == 2) {
            this.seeMoreFields = false;
            this.moreFieldsAction(false);

            setTimeout(() => {
                let fieldsByProtocol = this.getFieldsByProtocolId(this.fields, 2);
                let filteredDynamicFields = fieldsByProtocol.filter(
                    item => item['key'] !== 'standardrequest' && item['key'] !== 'pgnnumber'
                );
                for (let i = 0; i < filteredDynamicFields.length; i++) {
                    const field = filteredDynamicFields[i];

                    if (field['type'] === 'number' && field['model'] !== 0) {
                        this.seeMoreFields = true;
                        this.moreFieldsAction(true);
                    } else if (field['type'] === 'text') {
                        if (field['model'] !== '' && field['model'] !== '{}') {
                            this.seeMoreFields = true;
                            this.moreFieldsAction(true);
                        }
                    }
                }
            }, 0);
        }

        for (let index = 0; index < this.fields.length; index++) {
            let formField = this.fields[index];

            let fieldsToPatchKeys = Object.keys(this.fieldToPatch);

            for (let b = 0; b < fieldsToPatchKeys.length; b++) {
                const field = fieldsToPatchKeys[b];
                if (formField['key'] === field) {
                    if (formField['type'] === 'select') {
                        if (this.fieldToPatch[field] !== null) {
                            formField['model'] = {
                                value: this.fieldToPatch[field],
                                description: this.fieldToPatch[field].toString()
                            };
                        }
                    } else {
                        formField['model'] = this.fieldToPatch[field];
                    }
                }
            }
        }
    }

    setBreadcrums() {
        this.breadcrumsItems = [
            {
                text: 'Listado de ECUs',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuList'
            },
            {
                text: !this.editingEcu ? 'Crear Ecu' : 'Modificar ECU',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuDialog'
            },
            {
                text: this.editingProtocol ? 'Modificar Protocolo' : 'Crear Protocolo',
                disabled: false,
                href: '',
                active: false,
                action: 'back'
            },
            {
                text: this.editing ? 'Modificar ' + this.action : 'Crear ' + this.action,
                disabled: false,
                href: '',
                active: true,
                action: null
            }
        ];

        if (this.outsideProtocol) {
            this.breadcrumsItems.splice(2, 1);
        }
    }

    filterTypesOptions() {
        if (this.protocolSelected) {
            let protocolId = Number(this.protocolSelected['id']);
            this.typesOptions = this.optionsTypes.filter(item => item['protocol_id'].indexOf(protocolId) !== -1);
            if (this.typesOptions.length == 1) {
                this.updateSessionType(this.typesOptions[0]);
            }
        }
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    submitSessionFrame() {
        let self = this;
        self.scrollToTopOfModal();
        self.clearScrollLoadingDialog();
        let configuration = this.getPostConfiguration();
        if (!this.editing) {
            //post initialization y finalization
            self.pendingLoadingDialog('Generando ' + this.action + ' ...')

            if (this.action === 'Inicialización') {
                NormsServices.postCreateInitialization(configuration)
                    .then(response => {
                        // console.log("protocolo creado", response);
                        self.successPost = true;
                        self.handleSuccessAction(response);
                        self.pendingRequest = false;
                        self.closeModal();
                        self.$emit('add-new-initialization', response['initialization']);
                    })
                    .catch(error => {
                        self.handleErrorAction(error, 'No se pudo crear la inicialización');
                    });
            } else if (this.action === 'Finalización' || this.action === 'Session Frame') {
                NormsServices.postCreateFinalization(configuration)
                    .then(response => {
                        self.successPost = true;
                        self.handleSuccessAction(response);
                        self.pendingRequest = false;
                        self.closeModal();
                        self.$emit('add-new-finalization', response['finalization']);
                    })
                    .catch(error => {
                        self.handleErrorAction(error, 'No se pudo crear la finalización');
                    });
            }
        } else {
            //patch initialization y finalization
            self.pendingLoadingDialog('Modificando ' + this.action + ' ...')

            if (this.action === 'Inicialización') {
                NormsServices.patchInitialization(configuration, this.fieldToPatch['id'])
                    .then(response => {
                        // console.log("protocolo creado", response);
                        self.successPost = true;
                        self.handleSuccessAction(response.data);
                        self.pendingRequest = false;
                        self.closeModal();
                        self.$emit('update-initialization', response['data']['initialization']);
                    })
                    .catch(error => {
                        self.handleErrorAction(error, 'No se pudo modificar la inicialización');
                    });
            } else if (this.action === 'Finalización' || this.action === 'Session Frame') {
                NormsServices.patchFinalization(configuration, this.fieldToPatch['id'])
                    .then(response => {
                        self.successPost = true;
                        self.handleSuccessAction(response.data);
                        self.pendingRequest = false;
                        self.closeModal();
                        self.$emit('update-finalization', response['data']['finalization']);
                    })
                    .catch(error => {
                         self.handleErrorAction(error, 'No se pudo modificar la finalización');
                    });
            }
        }
        self.pendingGenerateSessionFrame(true);
    }
    scrollToTopOfModal() {
        $('.dialog-scroll').scrollTop(0);
    }

    pendingGenerateSessionFrame(value) {
        this.pendingRequest = value;
    }

    @Watch('dynamicFields', { deep: true })
    watchFormFields(fields) {
        let self = this;
        let counter = 0;
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            const fieldValue = fields[i]['model'];
            if (
                field['key'] !== 'filterdataarray' && 
                field['key'] !== 'filtermaskarray' &&
                field['key'] !== 'priority' &&
                field['key'] !== 'filterposition'
            ) {
                if (fieldValue == null || fieldValue === '') {
                    counter++;
                }
            }
        }
        self.existsEmptyFields = counter;
    }

    @Watch('protocolSelected', { deep: true, immediate: true })
    watchProtocolSelected() {
        this.updateFormFields();
    }

    @Watch('sessionType')
    watchSessionTypeSelected(sessionTypeSelected) {
        if (sessionTypeSelected) {
            let protocolId = this.protocolSelected['id'];
            let sessionTypeId = sessionTypeSelected['id'];

            if (sessionTypeSelected !== null) {
                this.updateFieldsInitialization(Number(protocolId), Number(sessionTypeId));
            } else {
                this.updateFieldsInitialization(-1, -1);
            }
        }
    }

    validateHexa(max_num, input_value) {
        let splitted = splitStringByCharacter(input_value, ',');
        let inputLength = splitted.length;
        if (input_value !== '{}' && inputLength > 1 && input_value.indexOf(',') == -1) {
            this.frameArrayIsValid = false;
            return 'Los valores se separan por coma';
        } else if (inputLength > max_num) {
            this.frameArrayIsValid = false;
            return 'Máximo ' + max_num + ' caracteres';
        } else {
            this.frameArrayIsValid = true;
            return true;
        }
    }

    updateFieldsInitialization(protocolId, sessionTypeId) {
        if (protocolId == -1 && sessionTypeId !== -1) {
            this.dynamicFields = this.fields;
        } else {
            this.dynamicFields = this.fields.filter(
                item => item['protocol_id'].indexOf(protocolId) !== -1 && item['s_types'].indexOf(sessionTypeId) !== -1
            );
        }
    }

    updateFieldsFinalization(protocolId) {
        if (protocolId == -1) {
            this.dynamicFields = this.fields;
        } else {
            this.dynamicFields = this.fields.filter(function(item) {
                if (item['finalization_id']) {
                    return item['finalization_id'].indexOf(protocolId) !== -1;
                }
            });
        }
    }

    resetCombobox(idx) {
        this.fields[idx]['model'] = null;
    }

    closeModal() {
        this.enableScrollLoadingDialog();
        this.$emit('close-modal', false);
        this.visibilityCloseConfirmationModal(false);
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    checkBoxChangeByUser(value) {
        if(!value){
            let indexValueDataArray = this.dynamicFields.findIndex(item => item['key'] === 'filterdataarray');
            let indexValueFilterMask = this.dynamicFields.findIndex(item => item['key'] === 'filtermaskarray');
            let indexValuePriority = this.dynamicFields.findIndex(item => item['key'] === 'priority');
            let indexValueFilterPosition = this.dynamicFields.findIndex(item => item['key'] === 'filterposition');
            
            if(indexValueDataArray !== -1){
                this.dynamicFields[indexValueDataArray]['model'] = '';
            }
            if(indexValueFilterMask !== -1){
                this.dynamicFields[indexValueFilterMask]['model'] = '';
            }
            if(indexValuePriority !== -1){
                this.dynamicFields[indexValuePriority]['model'] = '';
            }
            if(indexValueFilterPosition !== -1){
                this.dynamicFields[indexValueFilterPosition]['model'] = '';
            }
            this.updateFrameArray('')
        }
        this.moreFieldsAction(value);
    }

    moreFieldsAction(value) {
        let filteredFieldsByProtocol = this.getFieldsByProtocolId(this.fields, 2);
        let filteredVisibleFields;
        if (value) {
            filteredVisibleFields = filteredFieldsByProtocol;
        } else {
            filteredVisibleFields = filteredFieldsByProtocol.filter(
                item => item['key'] === 'standardrequest' || item['key'] === 'pgnnumber'
            );
        }
        this.dynamicFields = filteredVisibleFields;
    }

    getFieldsByProtocolId(array, protocol_id) {
        let protocolId = Number(protocol_id);
        return array.filter(item => item['protocol_id'].indexOf(protocolId) !== -1);
    }
    getPostConfiguration() {
        let data = {
            protocol_type: Number(this.protocolSelected['id'])
        };
        let objKey;
        if (this.action === 'Finalización' || this.action === 'Session Frame') {
            objKey = 'finalization_data';
        } else {
            objKey = this.sessionType['key'];
        }
        this.$set(data, objKey, {});
        let protocolName = this.protocolSelected['value'].toLowerCase();
        let frameArrayValue = this.frameArray === '' || this.frameArray == null ? '{}' : this.frameArray;
        this.$set(data[objKey], 'description', this.sessionFrameDescription);
        this.$set(data[objKey], 'framearray', frameArrayValue);
        this.$set(data[objKey], 'framelength', this.getFrameLength);

        let protocolData;
        this.$set(data[objKey], protocolName, {});
        protocolData = data[objKey][protocolName];
        let dynamic_fields;
        if (protocolName === 'j1939') {
            dynamic_fields = this.getFieldsByProtocolId(this.fields, data['protocol_type']);
        } else {
            dynamic_fields = this.dynamicFields;
        }

        if (protocolData !== 'scanner') {
            let indexMaskArray = getIndexFromList(dynamic_fields, 'key', 'filtermaskarray');
            let indexDataArray = getIndexFromList(dynamic_fields, 'key', 'filterdataarray');
            let indexFilterPosition = getIndexFromList(dynamic_fields, 'key', 'filterposition')
            let indexTxPriority = getIndexFromList(dynamic_fields, 'key', 'priority')
            
            if (indexTxPriority !== -1) {
                if (dynamic_fields[indexTxPriority]['model'] === '') {
                    dynamic_fields[indexTxPriority]['model'] = null;
                }
            }
            if (indexFilterPosition !== -1) {
                if (dynamic_fields[indexFilterPosition]['model'] === '') {
                    dynamic_fields[indexFilterPosition]['model'] = null;
                }
            }

            if (indexDataArray !== -1) {
                if (dynamic_fields[indexDataArray]['model'] === '') {
                    dynamic_fields[indexDataArray]['model'] = null;
                }
            }
            if (indexMaskArray !== -1) {
                if (dynamic_fields[indexMaskArray]['model'] === '') {
                    dynamic_fields[indexMaskArray]['model'] = null;
                }
                this.$set(protocolData, 'filterlength', this.getFilterLength(dynamic_fields[indexMaskArray]['model']));
            }
        }
        for (let i = 0; i < dynamic_fields.length; i++) {
            const field = dynamic_fields[i];
            let fieldKey = field['key'];
            if (field['type'] !== 'select') {
                this.$set(protocolData, fieldKey, field['model']);
            } else {
                this.$set(protocolData, fieldKey, field['model']['value']);
            }
        }

        // this.$set(data, objKey, {})
        // this.$set(data[objKey], 'description', this.sessionFrameDescription);
        // for (let i = 0; i < this.dynamicFields.length; i++) {
        //     const field = this.dynamicFields[i];
        //     if(field['type'] !== 'select'){

        //         this.$set(data[objKey], field['key'], field['model']);
        //     }else{
        //         this.$set(data[objKey], field['key'], field['model']['value']);
        //     }
        // }
        return data;
    }

    get getFrameLength() {
        let splitted = splitStringByCharacter(this.frameArray, ',');
        return splitted.length;
    }

    get visibilityFrameData() {
        if (!this.seeMoreFields) {
            return false;
        } else {
            if (this.sessionType !== null) {
                if (this.sessionType['id'] == 1) {
                    return false;
                }
            }

            return true;
        }
    }

    getFilterLength(model) {
        if(model == null){
            return model
        }else{
            let splitted = splitStringByCharacter(model, ',');
            let inputLength = splitted.length;
            return inputLength;
        }
    }

    clearScrollLoadingDialog() {
        $('html').css('overflow-y', 'hidden');
        $('.dialog-scroll').addClass('dialog-scroll--active');
    }

    closeModalLoadingDialog() {
        this.pendingRequest = false;
        this.successPost = null;
        this.msgLoadingDialog = '';
        this.enableScrollLoadingDialog();
    }

    enableScrollLoadingDialog() {
        $('.dialog-scroll').removeClass('dialog-scroll--active');
    }

    updateSessionType(option) {
        this.sessionType = option;
    }

    get checkIfFormIsValid() {
        if (this.action === 'Initialización') {
            if (
                //validate base fields
                this.sessionFrameDescription !== '' &&
                this.sessionType !== null
            ) {
                if (this.protocolSelected['id'] !== this.idScannerProtocol.toString()) {
                    //validate dynamic fields
                    if (this.existsEmptyFields > 0) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            } else {
                return false;
            }
        } else {
            if (
                //validate base fields
                this.sessionFrameDescription !== ''
            ) {
                if (!this.dynamicFieldsAreValid) {
                    return false;
                } else {
                    if (this.protocolSelected['id'] !== this.idScannerProtocol.toString()) {
                        //validate dynamic fields
                        if (this.existsEmptyFields > 0) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }
            } else {
                return false;
            }
        }
    }

    get showFieldsSection() {
        if (this.action === 'Inicialización') {
            return this.sessionType !== null;
        } else {
            return this.protocolSelected['value'] !== null;
        }
    }
}
